import type { LngLatCoord, RoutePathOption } from '@gpx-spa/geo-domain'

/** Polyline coordinates for a route path (full API resolution). */
export function rawCoordinatesForFormPath(p: RoutePathOption): LngLatCoord[] | null {
  const c = p.coordinates
  if (!c || c.length < 2) return null
  return c
}
